/** Shown when the cart on screen is the device's saved copy (Location Service Engine ``offline_cart``). */
import { WifiOff } from "lucide-react";

export default function OfflineCartNotice({ savedAt }) {
    const when = savedAt ? new Date(savedAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : null;
    return (
        <div role="status" data-testid="lse-offline-cart"
             className="rounded-2xl border border-amber-300 bg-amber-50 text-amber-900 dark:bg-amber-950/40 dark:text-amber-100 dark:border-amber-800 px-4 py-3 flex gap-3">
            <WifiOff size={18} className="shrink-0 mt-0.5" />
            <div className="text-sm">
                <p className="font-semibold">You're offline — showing your saved cart</p>
                <p className="text-xs mt-0.5 opacity-90">
                    It's view-only while you're offline: quantities, coupons and ordering come back when you reconnect,
                    and prices and stock refresh then.{when ? ` Saved ${when}.` : ""}
                </p>
            </div>
        </div>
    );
}
